import Notes from "./Notes";

export default Notes;



// WEBPACK FOOTER //
// ./src/components/Notes/index.js